import { useNavigate, Navigate } from 'react-router-dom';
import FormPageLayout from '../components/common/FormPageLayout';
import UpiScanner from '../components/pay/UpiScanner';
import { useConfig } from '../context/ConfigContext';
import { isScanPayAvailable } from '../utils/upi';

/** Scan & Pay step 1: get the payee, then continue to the pay form. */
export default function ScanPayPage() {
  const navigate = useNavigate();
  const { config } = useConfig();
  if (!isScanPayAvailable(config)) return <Navigate to="/" replace />;
  return (
    <FormPageLayout title="Scan & Pay" maxWidth="max-w-md">
      <UpiScanner onResult={(req) => navigate('/scan-pay/pay', { replace: true, state: { upiPayee: req } })} />
    </FormPageLayout>
  );
}
